<mat-form-field>
  <mat-label>{{ label() }}</mat-label>
  <input matInput [formField]="f">
  <mat-hint>{{n.value()}}</mat-hint>
  <mat-error>
    {{ f().errors()[0]?.message }}
  </mat-error>
  @if (b) {
    <span matTextSuffix class="negative"
          style="font-size: 140%; font-weight: bold">!</span>
  }
</mat-form-field>